var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOrganisationNarratives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.063 9.173c-.038 4.257-3.084 7.911-7.266 8.646-1.903.335-3.74.086-5.471-.79-.276-.139-.512-.058-.761-.013-.95.167-1.897.353-2.847.524a.735.735 0 0 1-.852-.85c.197-1.08.401-2.157.596-3.235a.4.4 0 0 0-.033-.248 8.66 8.66 0 0 1-.956-4.643c.143-2.057.92-3.854 2.323-5.37C4.066 1.822 5.618.918 7.455.564c2.934-.565 5.542.147 7.76 2.161 1.442 1.308 2.322 2.947 2.673 4.86.095.522.119 1.058.175 1.588M2.539 15.855c.089-.006.145-.006.2-.016.745-.138 1.491-.271 2.235-.419a1 1 0 0 1 .703.111c1.685.928 3.471 1.173 5.333.714 4.631-1.142 6.923-6.386 4.64-10.576C13.785 2.251 9.542.895 6.047 2.6 2.262 4.448.818 9.109 2.899 12.773a.85.85 0 0 1 .104.58c-.062.357-.134.715-.201 1.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.998 7.016c.02.615-.333 1.315-.962 1.892-.129.119-.256.242-.391.354-.462.385-.662.883-.659 1.476.003.388-.223.679-.573.76a.74.74 0 0 1-.917-.713c-.016-1.038.339-1.915 1.122-2.61q.26-.23.511-.474c.414-.401.451-.896.307-1.412-.14-.5-.525-.745-1.005-.86a1.7 1.7 0 0 0-1.054.085c-.549.229-.797.658-.803 1.243a.74.74 0 0 1-.486.697c-.284.105-.619.039-.803-.204-.1-.132-.187-.312-.193-.473-.062-1.433 1.017-2.671 2.444-2.846.837-.104 1.614.03 2.31.52.796.561 1.147 1.352 1.152 2.565M9.99 13.995a.735.735 0 0 1-.751.745.735.735 0 0 1-.743-.754.756.756 0 0 1 .767-.739c.411.005.73.332.727.748"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisationNarratives);
export default __webpack_public_path__ + "static/media/OrganisationNarratives.dcab33571aa48eabf6cade3ce1acdfdc.svg";
export { ForwardRef as ReactComponent };